export default "__VITE_ASSET__c431b478__"